import React, { Component, PropTypes} from 'react';
import ReactHowler from 'react-howler';
import raf from 'raf'; // requestAnimationFrame polyfill
import FloatingActionButton from 'material-ui/FloatingActionButton';
import IconMenu from 'material-ui/IconMenu';
import { ListItem} from 'material-ui/List';
import PlayIcon from 'material-ui/svg-icons/av/play-circle-filled';
import PauseIcon from 'material-ui/svg-icons/av/pause-circle-filled';
import LoadingIcon from 'material-ui/svg-icons/av/loop';
import MusicIcon from 'material-ui/svg-icons/image/music-note';

class AutoPlay extends Component {
  static propTypes = {
    src: PropTypes.string,
    title: PropTypes.string,
    time: PropTypes.string,
    playing: PropTypes.bool
  }
  constructor (props) {
    super(props)

    this.state = {
      open: false,
      playing: false,
      loading: false,
      loaded: false,
      loop: false,
      mute: false,
      volume: 1.0
    }
  }

  componentWillUnmount () {
    this.clearRAF()
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.src !== this.props.src){
      this.player.stop();
      this.state.playing = true;
    }
  }

  handleToggle () {
    this.setState({
      playing: !this.state.playing,
      loading: true,
      open: true,
    })
  }

  handleOnLoad () {
    this.setState({
      loading: false,
      loaded: true,
      duration: this.player.duration()
    })
  }

  handleOnPlay () {
    this.setState({
      playing: true,
      open: true,
    })
    this.renderSeekPos()
  }

  handleOnEnd () {
    this.setState({
      playing: false
    })
    this.clearRAF()
  }

  handleStop () {
    this.player.stop()
    this.setState({
      playing: false // Need to update our local state so we don't immediately invoke autoplay
    })
    this.renderSeekPos()
  }

  handleLoopToggle () {
    this.setState({
      loop: !this.state.loop
    })
  }

  handleMuteToggle () {
    this.setState({
      mute: !this.state.mute
    })
  }

  renderSeekPos () {
    this.setState({
      seek: this.player.seek()
    })
    if (this.state.playing) {
      this._raf = raf(this.renderSeekPos)
    }
  }

  clearRAF () {
    raf.cancel(this._raf)
  }

  toggleIcon

  render () {
    const { playing, loaded,  open } = this.state;
    const color = '#994433';
    this.toggleIcon = <PlayIcon color={color} />;
    if(playing){
      this.toggleIcon = loaded ? <PauseIcon color={color} /> : <LoadingIcon color={color} />;
    }

    /* let loadstatus = 'Play';
    if(playing){
      loadstatus = loaded ? 'Pause' : 'Loading...';
    }*/

    return (
      <div>
        <ReactHowler
          src={this.props.src}
          playing={playing}
          onLoad={() => this.handleOnLoad()}
          onPlay={() => this.handleOnPlay()}
          onEnd={() => this.handleOnEnd()}
          loop={this.state.loop}
          mute={this.state.mute}
          volume={this.state.volume}
          ref={(ref) => (this.player = ref)}
          />
      <IconMenu
        style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 21, display: open ? 'block' : 'none'}}
        iconButtonElement={<FloatingActionButton mini={true}><MusicIcon /></FloatingActionButton>}
        anchorOrigin={{horizontal: 'right', vertical: 'center'}}
        targetOrigin={{horizontal: 'right', vertical: 'center'}}
        containerStyle={{ background: '#FFF'}}
        >
          <ListItem
            leftIcon={<div className="time">{this.props.time}</div>}
            rightIcon={this.toggleIcon}
            style={{ fontWeight: 300}}
            primaryText={this.props.title}
            onTouchTap={() => this.handleToggle()} />
        </IconMenu>
         {/*<button onClick={this.handleStop}>
         <ListItem
           onTouchTap={() => this.handleToggle()}
           primaryText={this.props.title}
           leftIcon={<div className="time">{this.props.time}</div>}
           rightIcon={playing ? <PauseIcon /> : <PlayIcon />} /> )} />

        </button>
        <p>{ loadstatus }</p>
        <p>
          {'Status: '}
          {(this.state.seek !== undefined && this.state.seek.toFixed !== undefined) ? this.state.seek.toFixed(2) : 'NaN'}
          {' / '}
          {(this.state.duration) ? this.state.duration.toFixed(2) : 'NaN'}
        </p>
        <label>
          Loop:
          <input
            type='checkbox'
            checked={this.state.loop}
            onChange={this.handleLoopToggle}
          />
        </label>
        <label>
          Mute:
          <input
            type='checkbox'
            checked={this.state.mute}
            onChange={this.handleMuteToggle}
          />
        </label>
        <div>
          <label>
            <input
              type='range'
              min='0'
              max='1'
              step='.05'
              value={this.state.volume}
              onChange={e => this.setState({volume: parseFloat(e.target.value)})}
            />
            <br /> Volume: {this.state.volume}
          </label>
        </div> */}

      </div>
    )
  }
}

export default AutoPlay



// WEBPACK FOOTER //
// ./src/ReactPlayer.js